export class SessionlStorageKeys{
    public static FEATURE_AVAILABLE_BY_TOKEN: string = 'FEATURE_AVAILABLE_BY_TOKEN';

    public static REDEMPTIOIN_CODE_PARAM: string = 'REDEMPTIOIN_CODE_PARAM';
}